import { Component, input, model } from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: true,
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  title = input<string>();
  active = model<boolean>(false);
  disabled = input<boolean>();
  id = input<string>();
}
